export function setupStripe() {
    let stripe = null;
    const userEmail = document.body.hasAttribute('data-user') ? document.body.getAttribute('data-user') : null;

    function handleCheckout(result) {
        console.log('result', result);
        console.log('result.error', result.errore);
        // if (result.error) {
        //     var displayError = document.getElementById('error-message');
        //     displayError.textContent = result.error.message;
        // }
    }

    function getStripeObject() {
        stripe = Stripe('pk_live_51QU5E0G2qiSs4LB91zeSt5aFPT18huAxhQkf1pnqHRF9N9FJRvzWw0BnnmYTPNfiytJZ3ndu8U3VNZFekk2msPqh00oC8Rtwwg');
    }

    if (userEmail !== null) {
        const stripePriceLinks = document.querySelectorAll('[data-stripe-price-id]');
        stripePriceLinks.forEach(link => {
            link.addEventListener('click', async function(event) {
                event.preventDefault();

                if (stripe === null) {
                    getStripeObject();
                }

                const priceId = link.getAttribute('data-stripe-price-id');

                await fetch(`/Umbraco/Api/Subscription/GetSubscriptionCheckoutSessionId?priceId=${priceId}&customerEmail=${userEmail}`, {
                    method: 'GET'
                }).then(response => response.json()).then(data => {
                    if (data.success) {
                        console.log('test 1');
                        stripe.redirectToCheckout({
                            sessionId: data.sessionId
                        }).then(handleCheckout);
                    }
                });
            });
        });
    }
}